import axios from "axios";
import router from "../router/index";
import { showFullScreenLoading, tryHideFullScreenLoading } from "../loading";
import store from "../store";
import Vue from "vue";
// axios 配置
axios.defaults.timeout = 3 * 60 * 1000; //3分钟
axios.defaults.withCredentials = true;
axios.create({
  headers: {
    "Content-Type": "application/json"
  },
  // withCredentials: false
});
// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (localStorage.getItem("token")) {
      config.headers.Authorization = `token ${localStorage.getItem("token")}`;
    }
    // showFullScreenLoading()
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.code == 2 && response.data.msg == "未登录!") {
      //登出 需要清除缓存
      //提示信息
      localStorage.removeItem("token");
      localStorage.removeItem("phone");
      localStorage.removeItem("username");
      localStorage.removeItem("usinfo");
      localStorage.removeItem("uid");
      if (router.currentRoute.fullPath == "/") {
        Vue.prototype.$message.error("请重新登录");
        store.commit("setisLogin", 1);
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000);

        return response;
      } else {
        Vue.prototype.$message.error("请重新登录");
        setTimeout(() => {
          router.push("/");
          store.commit("setisLogin", 1);
          // router.replace({
          //   name: "login",
          //   params: { redirect: router.currentRoute.fullPath }
          // });
        }, 1000);
      }
      return;
    }
    tryHideFullScreenLoading();
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          localStorage.removeItem("token");
          localStorage.removeItem("username");
          localStorage.removeItem("uid");
          localStorage.removeItem("usinfo");
          // 401 清除token信息并跳转到登录页面
          // store.commit("hintMsg", "请重新登录");
          // store.commit("hintShow", 1000);
          Vue.prototype.$message.error("请重新登录");
          setTimeout(() => {
            router.push("/");
            store.commit("setisLogin", 1);
            // router.replace({
            //   name: "login",
            //   params: { redirect: router.currentRoute.fullPath }
            // });
          }, 1000);
          break;
        case 504:
          Vue.prototype.$message.error("请重新登录");
          break;
        default:
        //  router.push("/404");
      }
    } else {
     // router.push("/404");
    }
    // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
    return Promise.reject(error);
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/axios/axios.js